import React from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';

import { OCardFeature as OCardFeatureComp } from '@marriott/mi-web-ui-kit';
import clsx from 'clsx';

export const OCardFeatureConfig = {
  emptyLabel: 'OCardFeature',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/o-card-feature`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OCardFeature = (props: any) => {
  const model = props.model || {};
  const { styleclass, componentId } = model;

  return (
    <div
      data-testid="o-card-feature-comp"
      data-component-name="o-card-feature"
      id={componentId}
      className={clsx(styleclass)}
    >
      <EditableComponent config={OCardFeatureConfig} {...props}>
        <OCardFeatureComp {...props} />
      </EditableComponent>
    </div>
  );
};
